const ATTRIBUTION_QUERY = {
    view: "explore_conversion",
    fields: [],
    filters: {},
    limit: "20",
    column_limit: "50",
    model: "client_analytics"
};
const OVERLAP_QUERY = {
    view: "explore_overlap_conversion",
    fields: [],
    filters: {},
    limit: "-1",
    column_limit: "50",
    model: "client_analytics"
};
const LINEAR_QUERY = {
    view: "explore_linear_conversion",
    fields: [],
    filters: {},
    limit: "-1",
    column_limit: "50",
    model: "client_analytics"
};
export const REPORT_TYPE_TO_QUERY = {
    VIDEO: ATTRIBUTION_QUERY,
    AUDIO: ATTRIBUTION_QUERY,
    DISPLAY: ATTRIBUTION_QUERY,
    LINEAR: LINEAR_QUERY,
    OVERLAP: OVERLAP_QUERY
};
export const FILTER_OPTIONS_ADVERTISER_QUERY = {
    view: "explore_conversion_filter_suggests",
    fields: [
        "conversion_filter_suggests.advertiser_name",
        "conversion_filter_suggests.advertiser_id"
    ],
    filters: {
        "conversion_filter_suggests.filter_date_nyc": "",
        "conversion_filter_suggests.media_type": ""
    },
    sorts: ["conversion_filter_suggests.advertiser_name asc"],
    limit: "-1",
    column_limit: "500",
    model: "client_analytics"
};
export const FILTER_OPTIONS_LINEAR_ADVERTISER_QUERY = {
    view: "explore_linear_conversion_filter_suggests",
    fields: [
        "conversion_linear_suggests.advertiser_id",
        "conversion_linear_suggests.advertiser_name"
    ],
    filters: {
        "conversion_linear_suggests.flt_date_nyc": ""
    },
    sorts: ["conversion_linear_suggests.advertiser_name asc"],
    limit: "-1",
    column_limit: "500",
    model: "client_analytics"
};
export const FILTER_OPTIONS_CAMPAIGN_QUERY = {
    view: "explore_conversion_filter_suggests",
    fields: [
        "conversion_filter_suggests.campaign_name",
        "conversion_filter_suggests.campaign_id",
        "conversion_filter_suggests.lineitem_id"
    ],
    filters: {
        "conversion_filter_suggests.filter_date_nyc": "",
        "conversion_filter_suggests.advertiser_id": "",
        "conversion_filter_suggests.media_type": ""
    },
    sorts: ["conversion_filter_suggests.campaign_name desc"],
    limit: "-1",
    column_limit: "500",
    model: "client_analytics"
};
export const FILTER_OPTIONS_PIXEL_QUERY = {
    view: "explore_conversion_filter_suggests",
    fields: [
        "conversion_meta_beacon.name",
        "conversion_filter_suggests.beacon_id",
        "conversion_filter_suggests.pixel_type",
        "conversion_meta_beacon.beacon_status"
    ],
    filters: {
        "conversion_filter_suggests.filter_date_nyc": "",
        "conversion_filter_suggests.advertiser_id": "",
        "conversion_filter_suggests.media_type": "",
        "conversion_meta_beacon.beacon_status": ""
    },
    sorts: ["conversion_meta_beacon.name asc"],
    limit: "-1",
    column_limit: "500",
    model: "client_analytics"
};
export const FILTER_OPTIONS_COMMERCIAL_QUERY = {
    view: "explore_linear_conversion_filter_suggests",
    fields: ["conversion_linear_suggests.creative_id", "conversion_linear_suggests.creative_name"],
    filters: {
        "conversion_linear_suggests.flt_date_nyc": "",
        "conversion_linear_suggests.advertiser_id": ""
    },
    sorts: ["conversion_linear_suggests.creative_name asc"],
    limit: "-1",
    column_limit: "500",
    model: "client_analytics"
};
//# sourceMappingURL=query.js.map